module.exports = __webpack_public_path__ + "static/media/BuildingDAPPPicture.fbae07a6.png";